"use client";

import { getLink } from "@utils/linkUtils";
import { useLocale } from "next-intl";
import { FC, useMemo, useRef, useState } from "react";

import Button, { ButtonSize, ButtonTheme, ButtonVariant } from "../ui/Button/Button";
import ButtonOrVideoModal from "../ui/ButtonOrVideoModal/ButtonOrVideoModal";
import Icon from "../ui/Icon/Icon";
import Modal from "../ui/Modal/Modal";
import ModalContent from "../ui/Modal/ModalContent";
import VideoCard from "./VideoCard";
import { VideoCardProps, VideoListingProps } from "./types";

const VideoListing: FC<{ entry: VideoListingProps }> = ({ entry }) => {
  const locale = useLocale();
  const slicedCardsArr = useMemo(() => {
    if (entry?.cards) {
      const remainder = (entry.cards.length - 1) % 4;
      return entry.cards.slice(0, entry.cards.length - remainder);
    }
  }, [entry?.cards]);
  return (
    <div className="video-listing py-l md:py-[40px]">
      {/* <ul className="px-l md:p-0 md:w-20\/24 md:mx-auto md:grid md:grid-cols-4 md:gap-l"> */}
      <ul className="px-l md:p-0 md:mx-auto md:grid md:grid-cols-4 md:gap-l">
        {slicedCardsArr?.map((card, i) => {
          return <VideoCard index={i} card={card} key={i} />;
        })}
      </ul>
      {entry.cta && (
        <div className="flex items-center justify-center mt-l md:mt-[40px]">
          <a
            className="btn btn-medium btn-primary-white font-medium cursor-pointer"
            href={getLink(entry.cta, locale).toString()}
            target={entry.cta.link.target ?? ""}
          >
            {entry.cta.label}
          </a>
        </div>
      )}
    </div>
  );
};
export default VideoListing;
